
const digest = '6d7d64d2c04e9d57752da26e86199ac2dc6e3e7f9430d0e5ac509cac7a9a63d6';
const classes = {"input":"_input_18o6j_1","errorMessage":"_errorMessage_18o6j_20","invalid":"_invalid_18o6j_26"};
const css = `._input_18o6j_1 {
  border: 1px solid #e2e5ed;
  min-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 16px 20px;
  color: #000;
  background-color: #fff;
}
._input_18o6j_1:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}

._errorMessage_18o6j_20 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}

._invalid_18o6j_26 {
  border-color: #d81616 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  